export default __webpack_public_path__ + "static/media/sprinkler-center.b4b75869.jpg";